module.exports = __webpack_public_path__ + "static/media/plus-icon.70ca1268.svg";